import VideoWidget from "QuorumGrassroots/widgets/Video/components/index"

export default VideoWidget
